import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { catchError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AppropriationChargeCodesService extends DataService {

  private baseURI = this.apiUri + '/appropriationChargeCodes/';
  private chargeCodesFromAppropriationChargeCodes = new BehaviorSubject<number>(null);
  appropriationChargeCodes = this.chargeCodesFromAppropriationChargeCodes.asObservable().pipe(distinctUntilChanged());

  constructor(http: HttpClient) {
    super(http);
  }

  getAppropriationChargeCodesByOrganizationId(organizationId: number): Observable<any[]> {
    this.setUri(this.baseURI + organizationId + '/organizationId');
    return this.get().pipe(catchError(this.handleError));
  }

  saveAppropriationChargeCodes(appropriationChargeCodes: any): Observable<any> {
    const saveUrL = this.baseURI + 'saveAppropriationChargeCodes';
    return this.http.post(saveUrL, appropriationChargeCodes);
  }

  deleteAppropriationChargeCodes(appropriationChargeCodesId: any): Observable<any> {
    const deleteUrL = this.baseURI + 'deleteAppropriationChargeCodes';
    return this.http.post(deleteUrL, appropriationChargeCodesId);
  }

  setAppropriationChargeCodes(appropriationChargeCodes: number) {
    this.chargeCodesFromAppropriationChargeCodes.next(appropriationChargeCodes);
  }

  getAppropriationChargeCodes() {
    return this.appropriationChargeCodes;
  }

  getAppropriationChargeCodesByChargeCodes(ChargeCodes: any): Observable<any> {
    this.setUri(this.baseURI + ChargeCodes + '/chargeCodeList');
    return this.get().pipe(catchError(this.handleError));
  }

}
